import { MessageSquareQuote } from "lucide-react";
import StoreReviews from "~/components/admin/store/StoreReviews";
import StoreReviewComposer from "~/components/store/StoreReviewComposer";
import { useStoreContext } from "~/hooks/use-store";
import { Card, CardContent } from "~/components/ui/card";

export default function StorePageReviews() {
  const { storeReviews, storeDetails } = useStoreContext();
  const storeName = (storeDetails.name ?? "").trim();

  return (
    <div className="flex flex-1 flex-col">
      <section className="flex-1 w-full py-12 md:py-24 lg:py-12">
        <div className="container px-4 md:px-6 max-w-7xl mx-auto">
          <div className="mb-12 space-y-6">
            <h3 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-gray-100">
              Reviews
            </h3>
            <StoreReviewComposer />
            {storeReviews.length > 0 ? (
              <div className="space-y-4">
                {storeReviews.map((review) => (
                  <Card
                    key={review.id}
                    className="w-full rounded-2xl border border-gray-200/80 bg-white shadow-sm hover:shadow-md transition-shadow dark:border-gray-700 dark:bg-gray-900/40"
                  >
                    <CardContent className="pt-6">
                      <StoreReviews {...review} />
                    </CardContent>
                  </Card>
                ))}
              </div>
            ) : (
              <div className="flex w-full flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 bg-white/80 px-6 py-14 text-center shadow-sm dark:border-gray-600 dark:bg-gray-900/30">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-orange-50 text-orange-600 dark:bg-orange-950/50 dark:text-orange-400">
                  <MessageSquareQuote className="h-7 w-7" strokeWidth={1.5} />
                </div>
                <p className="mt-4 text-base font-semibold text-gray-900 dark:text-gray-100">
                  No reviews yet
                </p>
                <p className="mt-2 max-w-md text-sm text-gray-500 dark:text-gray-400">
                  {`When customers leave feedback for ${storeName}, it will show up here.`}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
